import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';

import Form from 'react-jsonschema-form';
import ObjectFieldTemplate from './ObjectFieldTemplate';
import FieldTemplate from './FieldTemplate';
import DateTimeWidget from './DateTimeWidget';
import CloudinaryFileWidget from './CloudinaryFileWidget';
import Spinner from '../common/spinner';

import './formViewer.css';

const CUSTOM_FORMATS = { 'data-url': () => true };

const sanitizeSchema = (schema) => {
  if (!schema || !schema.properties) return schema;
  const cleanProps = {};
  Object.keys(schema.properties).forEach((key) => {
    // eslint-disable-next-line no-unused-vars
    const { required: _omit, ...rest } = schema.properties[key];
    cleanProps[key] = rest;
  });
  return { ...schema, properties: cleanProps };
};

class FormViewer extends PureComponent {
  render() {
    const {
      additionClasses,
      schema,
      uiSchema,
      formData,
      formContext,
      isSubmitting,
      canSubmit,
      fieldTemplate,
      onChange,
      onSubmit,
      onError
    } = this.props;
    const additonalProperties = {};

    additonalProperties.FieldTemplate = fieldTemplate || FieldTemplate;

    const rawLabel = formContext && formContext.buttonLabel;
    const label = rawLabel === '' || rawLabel ? rawLabel : 'Submit';
    const color = (formContext && formContext.buttonColor) || '#5986ff';
    const hasCustomColor = !!color;

    const submitButton = canSubmit
      ? (
        <button
          type="submit"
          className={hasCustomColor ? 'btn btn-block btn-lg' : 'btn btn-success btn-block btn-lg'}
          style={hasCustomColor ? {
            backgroundColor: color,
            borderColor: color,
            color: '#fff',
            marginTop: 16
          } : {}}
          disabled={isSubmitting}
        >
          {label}
          <Spinner isLoading={isSubmitting} />
        </button>
      )
      // Use Fragment to avoid the form rendering a default button (on null or undefined)
      : <Fragment />;

    return (
      schema && (
        <Form
          widgets={{
            DateTimeWidget,
            FileWidget: CloudinaryFileWidget,
          }}
          ObjectFieldTemplate={ObjectFieldTemplate}
          schema={sanitizeSchema(schema)}
          className={`form-viewer ${additionClasses}`}
          uiSchema={uiSchema}
          formData={formData}
          formContext={formContext}
          customFormats={CUSTOM_FORMATS}
          onChange={onChange}
          onSubmit={onSubmit}
          onError={onError}
          showErrorList={false}
          disabled={isSubmitting}
          {... additonalProperties}
        >
          { submitButton }
        </Form>
      )
    );
  }
}

FormViewer.defaultProps = {
  additionClasses: '',
  formData: {},
  formContext: {},
  isSubmitting: false,
  canSubmit: true,
  fieldTemplate: null,
  onChange: () => {},
  onSubmit: () => {},
  onError: () => {}
};

FormViewer.propTypes = {
  additionClasses: PropTypes.string,
  schema: PropTypes.shape({
    title: PropTypes.string.isRequired
  }).isRequired,
  uiSchema: PropTypes.shape({
    'ui:order': PropTypes.arrayOf(PropTypes.string).isRequired
  }).isRequired,
  canSubmit: PropTypes.bool,
  formData: PropTypes.shape({}),
  formContext: PropTypes.shape({
    headerImage: PropTypes.string,
    buttonLabel: PropTypes.string,
    buttonColor: PropTypes.string,
  }),
  isSubmitting: PropTypes.bool,
  fieldTemplate: PropTypes.func,
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  onError: PropTypes.func
};

export default FormViewer;
